import { render, staticRenderFns } from "./VCheckBoxV2.vue?vue&type=template&id=27d4eb6e&scoped=true&"
import script from "./VCheckBoxV2.vue?vue&type=script&lang=js&"
export * from "./VCheckBoxV2.vue?vue&type=script&lang=js&"
import style0 from "./VCheckBoxV2.vue?vue&type=style&index=0&id=27d4eb6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d4eb6e",
  null
  
)

export default component.exports